import React from "react"
import { Link } from "gatsby"
import CookieConsent from 'react-cookie-consent';

const Footer = ({}) => {
  return (
    <footer id="site-footer" role="contentinfo" className="header-footer-group">
      <CookieConsent
          enableDeclineButton
          disableStyles={true}
          containerClasses="cooConsent"
          contentClasses="cooConsentContent"
          buttonClasses="cooConsentButton"
          declineButtonClasses="cooConsentButtonDecline"
          location="bottom"
          buttonText="Kabul Et"
          declineButtonText="Reddet"
          cookieName="gatsby-gdpr-google-analytics">
          Size daha iyi hizmet verebilmek için çerezleri kullanıyoruz. 
      </CookieConsent>
      <div className="section-inner">
        <div className="footer-credits">
          <p className="footer-copyright">
            © {new Date().getFullYear()}{" "}
            <Link to={"/"}>TeknoAsist.com İnternet Yardım Hattı</Link>
          </p>
          <p>
            <a
              className="powered-by-wordpress"
              href="mailto:merhaba@teknoasist.com"
              rel="noreferrer noopener"
            >
              merhaba@teknoasist.com  
            </a>
          </p>
        </div>

        <a className="to-the-top" href="#site-header">
          <span className="to-the-top-long">
            En Başa Gönder{" "}
            <span className="arrow" aria-hidden="true">
              ↑
            </span>
          </span>
          <span className="to-the-top-short">
            Yukarı{" "}
            <span className="arrow" aria-hidden="true">
              ↑
            </span>
          </span>
        </a>
      </div>
    </footer>
  )
}

export default Footer
